// Samp TopicalSections


const SampleTopicalSections  =  [


   //  ==== Wakeboard boot ================================

 
    {
      id: 'tSection_1',
      topic: 'topic_1',
      title: 'New topical - Wakeboard boot',

      topicalDate: '2021-01-24T23:58:38.000Z',
      lastEdit: '2021-01-24T23:58:38.000Z',
      timeLock: '',  // if exists - not editable

      detail :"<div>Decided to create a record of the development of my waterski boot idea.&nbsp;The dream would be that the feature idea might turn into a product idea… which might turn into a business for Mary and me.</div><div>&nbsp;</div><div>The basic product idea is to have a mechanical boot that transitions the wakeboard horizontal boot position to an inline&nbsp;vertical waterski style boot position.&nbsp;&nbsp;</div>", 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: [],

    },

    {
      id: 'tSection_2',
      topic: 'topic_1',
      title: 'Initial research',

      topicalDate: '2021-02-04T06:08:53.000Z',
      lastEdit: '2021-02-04T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : "<div>I haven’t found anything like I’ve imagined for the “transition boot”&nbsp;on line yet.&nbsp;Doesn’t mean that it doesn’t exist… just means that either a) it is a unique idea or b) it’s not a product that has any traction yet.</div>", 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: [],

    },


    {
      id: 'tSection_3',
      topic: 'topic_1',
      title: 'First tell of idea',

      topicalDate: '2021-02-10T06:08:53.000Z',
      lastEdit: '2021-02-10T06:08:53.000Z',
      timeLock: '2021-02-10T06:08:53.000Z',  // if exists - not editable

      detail : '<div>Told my idea to <strong style="color: rgb(230, 0, 0);">Jerry</strong>.&nbsp;He likes the idea - says he has a mechanical engineer friend who is also a skier who might be interested in the idea.&nbsp;</div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: ['Jerry G'], 
      keywordArray: [],

    },

    {
      id: 'tSection_4',
      topic: 'topic_1',
      title: 'Mechanical engineer',

      topicalDate: '2021-02-16T06:08:53.000Z',
      lastEdit: '2021-02-16T06:08:53.000Z',
      timeLock: '2021-02-16T06:08:53.000Z',  // if exists - not editable

      detail : '<div>Spoke to Jerry’s friend (<strong style="color: rgb(230, 0, 0);">Steve</strong>) about “slide boot” (another name try).&nbsp;As an ME he thinks it’s doable … as a skier he has his doubts.&nbsp;He thinks skiers and wakeboarders are really two different animals.</div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: ['Steve - Jerry friend'], 
      keywordArray: [],

    },

    {
      id: 'tSection_5',
      topic: 'topic_1',
      title: 'Track and Lever',

      topicalDate: '2021-02-22T06:08:53.000Z',
      lastEdit: '2021-02-22T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : '<div> Been doing a lot more searching - nothing yet.&nbsp;I’m getting excited.</div><div>&nbsp;</div><div><span style="color: rgb(153, 51, 255);">Thought about a track and lever design for moving the boots from one position to the other.&nbsp;&nbsp;I figure the trigger can come from a toe plate.</span></div><div>&nbsp;</div><div>A friend suggested an electromechanical switch… but I really don’t like the idea of electronics… especially with the pounding the board is going to take from doing jumps and tricks.</div><div> </div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: ['idea'],

    },

    {
      id: 'tSection_6',
      topic: 'topic_1',
      title: '',

      topicalDate: '2021-03-09T06:08:53.000Z',
      lastEdit: '2021-03-09T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : '<div>Jerry’s friend <strong style="color: rgb(230, 0, 0);">Steve </strong>called - says he has some design sketches.&nbsp;</div><div>&nbsp;</div><div>Now that there is someone else thinking about the idea with me, must come up with some business outline structure.&nbsp;If it goes any further, Steve will probably want money or ownership… and that leads to all sorts of decisions and implications.</div', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: ['Steve - Jerry friend'], 
      keywordArray: [],

    },


    //  ==== VLOG ================================
    {
      id: 'tSection_7',
      topic: 'topic_2',
      title: 'Vlogs',

      topicalDate: '2021-03-03T06:08:53.000Z',
      lastEdit: '2021-03-03T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : '<div>I’ve been researching the wakeboard boot.&nbsp;Finding a lot of cool stuff -- ideas, videos, lessons, products etc.&nbsp;</div><div>&nbsp;</div><div>I thought it would be cool to share these things I’m finding with other skiers and boarders.&nbsp;It would be fun and if the Wakeboard boot turns into a real product, having a blog following can only help me turn the boot into money.</div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: [],

    },

    {
      id: 'tSection_8',
      topic: 'topic_2',
      title: '',

      topicalDate: '2021-03-03T06:08:53.000Z',
      lastEdit: '2021-03-03T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : '<div>first&nbsp;vlog is going to be about <span style="color: rgb(161, 0, 0);">waterskiing … and boots … combo, freeride, crossover</span> ,etc.</div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: ['idea'],

    },

    {
      id: 'tSection_9',
      topic: 'topic_2',
      title: '',

      topicalDate: '2021-03-10T06:08:53.000Z',
      lastEdit: '2021-03-10T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : '<div>Got our waterski club to agree to help me create the Vlogs… We have some pretty great skiers who would love to show the equipment in action.</div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: [],

    },


    {
      id: 'tSection_10',
      topic: 'topic_3',
      title: '',

      topicalDate: '2021-01-03T06:08:53.000Z',
      lastEdit: '2021-03-03T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : '<div>Starting a new diet today.  Decided on the Mediterranean.  See if I can lose 15 pounds before vacation. </div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: [],

    },

    {
      id: 'tSection_11',
      topic: 'topic_3',
      title: '',

      topicalDate: '2021-01-04T06:08:53.000Z',
      lastEdit: '2021-01-04T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : '<div>Me - definitely a carnivore ... but got to admit - the salmon Mary made last night was really good.  Kale not so much.  Giving up on my bagel and cream cheese for breakfast is going to be a challenge.  </div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: [],

    },

    {
      id: 'tSection_12',
      topic: 'topic_3',
      title: '',

      topicalDate: '2021-01-05T06:08:53.000Z',
      lastEdit: '2021-01-05T06:08:53.000Z',
      timeLock: '',  // if exists - not editable

      detail : '<div>4 days now - Really hungry ...  <span style="color: rgb(161, 0, 0);">started to use Chit Git personal chits to keep track of progress.</span></div>', 

      attachment: '',
      
      chitLink: {}, //{dbCollection: 'personalChits', id: 'XYZ'}
     
      peopleArray: [], 
      keywordArray: [],

    },

]// end SampleTopicalSection

export default SampleTopicalSections